import { useCallback } from 'react';
import { renderComponentsSlice } from './renderComponentsStore';
import { useFastDispatch } from '../../context/FastContext';
export const useAddRenderComponents = () => {
  const dispatch = useFastDispatch();
  return useCallback(renderComponents => {
    dispatch(renderComponentsSlice.actions.setMultipleRenderComponents(renderComponents));
  }, [dispatch]);
};